<template>
  <div>
    <UpdateCompanyDomain></UpdateCompanyDomain>
    <MasterLayout>
      <section class="row card-loader-wrapper w-100" v-if="showLoader">
        <div class="col-md-3 position-relative" v-for="(c, i) in 4" :key="i">
          <div class="card-loader"></div>
        </div>
        <!-- LOADER -->
        <div
          class="showLoaderDiv charts__loader w-full mt-5 rounded-lg w-full"
          style="width: 130% !important; height: 100%"
          v-if="showLoader"
        >
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
        <!-- END LOADER -->
      </section>

      <section class="dashboard_first_row pt-2" v-if="!showLoader">
        <!-- <img src="@/assets/img/ReferBanner.png" class="remisAD" /> -->
        <div
          class="d-flex justify-content-between align-middle flex-lg-row flex-md-row date-picker mx-auto"
        >
          <h5
            style="font-size: 1.1rem; padding-top: 20px; display: block"
            v-if="!showLoader"
          >
            {{ $t("text.cDashboard.salesReport") }}
          </h5>

          <div class="drop_down_div align-items-center">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :custom-shortcuts="customShortcuts"
              :color="$store.getters.getDatePickerColor"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
        </div>
        <!-- TOP GRAPH CARD DIV STARTS-->
        <div class="row scoll-pane position-relative" id="scoll-pane">
          <div
            class="col-md-3 col-sm-12 card_row col-lg-3"
            :class="productCount"
            v-if="hasPms && !pmsCond"
          >
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header">
                    {{ countryProducts.products.product1 }}
                  </h4>
                  <!-- <h4 class="stations_card_header">{{ $d(new Date(), 'long', this.$root.$i18n.locale) }}</h4> -->
                </div>
                <div class="right_div">
                  <h4 class="stations_card_header" style="font-size: 20px">
                    {{ convertThousand(pmsSummary.volume) }}
                    {{ $t("text.cDisconnectedPumps.ltrs") }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts :options="pmsSplineOption" class=""></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': pmsRateColor }"
                  >
                    <span>
                      <img v-if="pmsUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!pmsUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${pmsRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="dashboard__footer__amount" style="font-size: 23px">
                    {{ company ? company.currencyCode : "" }}
                    {{ convertThousand(pmsSummary.amount) }}
                    <!-- {{ $n(pmsSummary.amount, 'currency') }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 remove-padding-left card_row"
            v-if="!hasPms && !getting"
          >
            <div class="mt-3 card_container_greyed dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h5 class="percent__text">
                    {{ $t("text.cDisconnectedPumps.na") }}
                  </h5>
                </div>
                <div class="right_div">
                  <h5 class="percent__text">
                    {{ $t("text.cDisconnectedPumps.na") }}
                  </h5>
                </div>
              </div>

              <div class="clearfix">
                <div class="pl-3 mt-2 mb-3">
                  <div class="text-right col-lg-12 col-md-12 col-sm-12">
                    <hr />
                  </div>
                </div>
                <div class="left_div">
                  <h5 class="percent__text">
                    {{ $t("text.cDisconnectedPumps.na") }}
                  </h5>
                </div>
                <div class="right_div">
                  <h5 class="percent__text">
                    {{ $t("text.cDisconnectedPumps.na") }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 remove-padding-left card_row"
            :class="productCount"
            v-if="hasAgo && !agoCond"
          >
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_1">
                    {{ countryProducts.products.product2 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_header_1" style="font-size: 20px">
                    {{ convertThousand(agoSummary.volume) }}
                    {{ $t("text.cDisconnectedPumps.ltrs") }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts :options="agoSplineOption" class=""></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': agoRateColor }"
                  >
                    <span>
                      <img v-if="agoUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!agoUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${agoRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="dashboard__footer__amount_1"
                    style="font-size: 23px"
                  >
                    {{ company ? company.currencyCode : "" }}
                    {{ convertThousand(agoSummary.amount) }}
                    <!-- {{ $n(agoSummary.amount, 'currency') }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 remove-padding-left card_row"
            v-if="!hasAgo && !getting"
          >
            <div class="mt-3 card_container_greyed dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h5 class="percent__text">
                    {{ $t("text.cDisconnectedPumps.na") }}
                  </h5>
                </div>
                <div class="right_div">
                  <h5 class="percent__text">
                    {{ $t("text.cDisconnectedPumps.na") }}
                  </h5>
                </div>
              </div>

              <div class="clearfix">
                <div class="pl-3 mt-2 mb-3">
                  <div class="text-right col-lg-12 col-md-12 col-sm-12">
                    <hr />
                  </div>
                </div>
                <div class="left_div">
                  <h5 class="percent__text">
                    {{ $t("text.cDisconnectedPumps.na") }}
                  </h5>
                </div>
                <div class="right_div">
                  <h5 class="percent__text">
                    {{ $t("text.cDisconnectedPumps.na") }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 remove-padding-left card_row"
            :class="productCount"
            v-if="hasDpk && !dpkCond"
          >
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_2">
                    {{ countryProducts.products.product3 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="stations_card_amount_header_3"
                    style="font-size: 20px"
                  >
                    {{ convertThousand(dpkSummary.volume) }}
                    {{ $t("text.cDisconnectedPumps.ltrs") }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts :options="dpkSplineOption" class=""></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': dpkRateColor }"
                  >
                    <span>
                      <img v-if="dpkUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!dpkUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${dpkRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="dashboard__footer__amount_2"
                    style="font-size: 23px"
                  >
                    {{ company ? company.currencyCode : "" }}
                    {{ convertThousand(dpkSummary.amount) }}
                    <!-- {{ $n(dpkSummary.amount, 'currency') }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-md-3 remove-padding-left card_row"
            :class="productCount"
            v-if="hasLpg && !lpgCond"
          >
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_2" style="color: purple">
                    {{ countryProducts.products.product4 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="stations_card_amount_header_3"
                    style="color: purple; font-size: 20px"
                  >
                    {{ convertThousand(lpgSummary.volume) }}
                    {{ $t("text.cDisconnectedPumps.ltrs") }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts :options="lpgSplineOption" class=""></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': lpgRateColor }"
                  >
                    <span>
                      <img v-if="lpgUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!lpgUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${lpgRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="dashboard__footer__amount_2"
                    style="font-size: 23px; color: purple"
                  >
                    {{ company ? company.currencyCode : "" }}
                    {{ convertThousand(lpgSummary.amount) }}
                    <!-- {{ $n(lpgSummary.amount, 'currency') }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 remove-padding-left card_row"
            :class="productCount"
          >
            <div
              class="mt-3 card_container_1 dashboard_card_1"
              v-if="!showLoader"
            >
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_3">
                    {{ $t("text.products.total") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="stations_card_amount_header_4"
                    style="font-size: 20px"
                  >
                    {{
                      convertThousand(
                        pmsSummary.volume +
                          agoSummary.volume +
                          dpkSummary.volume +
                          lpgSummary.volume
                      )
                    }}
                    {{ $t("text.cDisconnectedPumps.ltrs") }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts
                    :options="totalSplineOption"
                    class=""
                  ></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': totalRateColor }"
                  >
                    <span>
                      <img v-if="totalUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!totalUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${totalRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="dashboard__footer__amount_3"
                    style="font-size: 23px"
                  >
                    {{ company ? company.currencyCode : "" }}
                    {{
                      convertThousand(
                        pmsSummary.amount +
                          agoSummary.amount +
                          dpkSummary.amount +
                          lpgSummary.amount
                      )
                    }}
                    <!-- {{ $n((pmsSummary.amount + agoSummary.amount + dpkSummary.amount + lpgSummary.amount), 'currency') }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- TOP GRAPH CARD DIV ENDS-->

        <!-- NAV ARROWS FOR GRAPH CARDS -->
        <div v-if="prodCounts > 3 && lpgCond == false">
          <div
            @click="arrowLeft"
            @mouseover="arrowLeft"
            class="position-absolute rounded-circle arrow-div-left"
          >
            <img
              class="arrowpics"
              src="@/assets/img/arrowLeft.png"
              width="40px"
            />
          </div>
          <div
            @click="arrowRight"
            @mouseover="arrowRight"
            class="position-absolute rounded-circle arrow-div-right"
          >
            <img
              class="arrowpics"
              src="@/assets/img/arrowRight.png"
              width="40px"
            />
          </div>
        </div>
      </section>
      <div class="section-2 mt-4" v-if="!showLoader">
        <!-- OLD DASHBOARD STARTS HERE-->
        <section
          v-if="
            userInfo.roles.includes('Old Client') ||
            userInfo.email == 'supportest@gmail.com'
          "
          class="mt-5 section_3 last__ten__transactions__row"
        >
          <div class="row mb-5" style="margin-top: -10px">
            <div class="col-md-12 col-lg-8 table_block">
              <!-- TOTAL TANKS CONSUMPTION REPORT -->
              <h5
                style="
                  font-size: 1.1rem;
                  margin-bottom: -5px;
                  padding-left: 10px;
                "
              >
                <span
                  v-if="
                    hasTankStockPms ||
                    hasTankStockAgo ||
                    hasTankStockDpk ||
                    hasTankStockLpg
                  "
                >
                  {{ $t("text.cDashboard.productInventory") }}
                </span>
              </h5>
              <div
                class="row mb-2 pos_trans_card_holder mb-3"
                v-if="!showLoader"
              >
                <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="[LGgridNum, MDgridNum]"
                  v-if="hasTankStockPms"
                >
                  <div
                    class="card_container_1 pos-card mt-3 card-vertical-center"
                  >
                    <h4 class="stations_card_header">
                      {{ countryProducts.products.product1 }}
                    </h4>
                    <div class="oil_drop_div_1">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h4 style="font-size: 1.3rem">
                        {{ convertThousand(pmsTankStock.volume)
                        }}{{ $t("text.cDisconnectedPumps.ltrs") }}
                      </h4>
                    </div>
                  </div>
                </div>

                <!-- NO PMS N/A -->
                <!-- <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="
                  v-if="!hasTankStockPms"
                >
                  <div
                    class="
                      card_container_greyed
                      pos-card
                      mt-3
                      card-vertical-center
                    "
                  >
                    <h5 class="stations_card_header disabled-text">PMS</h5>
                    <div class="oil_drop_div_1 disabled-label-bg">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h5 class="">N/A</h5>
                    </div>
                  </div>
                </div> -->
                <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="[LGgridNum, MDgridNum]"
                  v-if="hasTankStockAgo"
                >
                  <div
                    class="card_container_1 pos-card mt-3 card-vertical-center"
                  >
                    <h5 class="stations_card_header_1">
                      {{ countryProducts.products.product2 }}
                    </h5>
                    <div class="oil_drop_div_2">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h4 style="font-size: 1.3rem">
                        {{ convertThousand(agoTankStock.volume)
                        }}{{ $t("text.cDisconnectedPumps.ltrs") }}
                      </h4>
                    </div>
                  </div>
                </div>

                <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="[LGgridNum, MDgridNum]"
                  v-if="hasTankStockDpk"
                >
                  <div
                    class="card_container_1 pos-card mt-3 card-vertical-center"
                  >
                    <h4 class="stations_card_header_2">
                      {{ countryProducts.products.product3 }}
                    </h4>
                    <div class="oil_drop_div_3">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h4 style="font-size: 1.3rem">
                        {{ convertThousand(dpkTankStock.volume)
                        }}{{ $t("text.cDisconnectedPumps.ltrs") }}
                      </h4>
                    </div>
                  </div>
                </div>

                <!-- NO DPK N/A -->
                <!-- <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="
                  v-if="!hasTankStockDpk"
                >
                  <div
                    class="
                      card_container_greyed
                      pos-card
                      mt-3
                      card-vertical-center
                    "
                  >
                    <h5 class="stations_card_header disabled-text">DPK</h5>
                    <div class="oil_drop_div_1 disabled-label-bg">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h5 class="">N/A</h5>
                    </div>
                  </div>
                </div> -->

                <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="[LGgridNum, MDgridNum]"
                  v-if="hasTankStockLpg"
                >
                  <div
                    class="card_container_1 pos-card mt-3 card-vertical-center"
                  >
                    <h4 class="stations_card_header_1" style="color: purple">
                      {{ countryProducts.products.product4 }}
                    </h4>
                    <div class="oil_drop_div_4" style="background: purple">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h4 style="font-size: 1.3rem">
                        {{ convertThousand(lpgTankStock.volume)
                        }}{{ $t("text.cDisconnectedPumps.kg") }}
                      </h4>
                      <small class="dashboard__card__header_bottom"> </small>
                    </div>
                  </div>
                </div>

                <!-- NO LPG N/A -->
                <!-- <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="productCount"
                  v-if="!hasTankStockLpg"
                >
                  <div
                    class="
                      card_container_greyed
                      pos-card
                      mt-3
                      card-vertical-center
                    "
                  >
                    <h5 class="stations_card_header disabled-text">LPG</h5>
                    <div class="oil_drop_div_1 disabled-label-bg">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h5 class="">N/A</h5>
                    </div>
                  </div>
                </div> -->
              </div>

              <div
                class="section_3_table_section"
                :class="
                  !hasTankStockPms &&
                  !hasTankStockAgo &&
                  !hasTankStockDpk &&
                  !hasTankStockLpg &&
                  'full-div'
                "
              >
                <!-- <h3 class="ml-2 sales_vs_target_header">Sales vs Target</h3> -->
                <pulse-loader
                  size="15px"
                  v-if="showLoader"
                  class="py-5"
                ></pulse-loader>
                <div class="row top_section_row py-5" v-show="!showLoader">
                  <div class="col-md-8">
                    <h3 class="ml-2 sales_vs_target_header">
                      {{ $t("text.cDashboard.salesVTarget") }}
                    </h3>
                    <span> </span>
                  </div>
                  <div class="col-md-4 section___column_2">
                    <div class="align-items-center">
                      <div class="">
                        <div class="mt-2 mr-2 drop_down_section">
                          <div class="drop_down_div align-items-center"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-2 highcharts__row">
                  <div class="mt-2 row">
                    <div
                      class="col-md-4"
                      :class="salesTargetCount"
                      v-if="hasPms"
                    >
                      <div class="highcharts__div">
                        <highcharts
                          :options="pmsGuageOptions"
                          class=""
                        ></highcharts>
                      </div>
                    </div>
                    <div
                      class="col-md-4"
                      :class="salesTargetCount"
                      v-if="!hasPms && !getting"
                    >
                      <div class="greyed_pie_chart_holder">
                        <highcharts
                          :options="greyedGuageOptions"
                          class=""
                        ></highcharts>
                        <div class="empty_chart_text">
                          <p>{{ $t("text.cDisconnectedPumps.na") }}</p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-4"
                      :class="salesTargetCount"
                      v-if="hasAgo"
                    >
                      <div class="highcharts__div">
                        <highcharts
                          :options="agoGuageOptions"
                          class=""
                        ></highcharts>
                      </div>
                    </div>
                    <div
                      class="col-md-4"
                      :class="salesTargetCount"
                      v-if="!hasAgo && !getting"
                    >
                      <div class="greyed_pie_chart_holder">
                        <highcharts
                          :options="greyedGuageOptions"
                          class=""
                        ></highcharts>
                        <div class="empty_chart_text">
                          <p>{{ $t("text.cDisconnectedPumps.na") }}</p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-4"
                      :class="salesTargetCount"
                      v-if="hasDpk"
                    >
                      <div class="highcharts__div">
                        <highcharts :options="dpkGuageOptions"></highcharts>
                      </div>
                    </div>
                    <!-- <div class="col-md-4" :class="salesTargetCount" v-if="!hasDpk && !getting">
                      <div class="greyed_pie_chart_holder">
                        <highcharts
                          :options="greyedGuageOptions"
                          class=""
                        ></highcharts>
                        <div class="empty_chart_text">
                          <p>N/A</p>
                        </div>
                      </div>
                    </div> -->
                    <div
                      class="col-md-3"
                      :class="salesTargetCount"
                      v-if="hasLpg"
                    >
                      <div class="highcharts__div">
                        <highcharts
                          :options="lpgGuageOptions"
                          class=""
                        ></highcharts>
                      </div>
                    </div>
                  </div>
                  <div class="mt-5 legend__div">
                    <div class="mt-5 row">
                      <div class="col-md-6">
                        <div class="row">
                          <div
                            class="col-md-3"
                            v-if="hasPms"
                            :class="salesTargetCount"
                          >
                            <div class="row align-items-center">
                              <div class="col-md-3">
                                <div
                                  style="
                                    height: 10px;
                                    width: 30px;
                                    background: rgb(216, 153, 28);
                                  "
                                ></div>
                              </div>
                              <div class="col-md-6">
                                <div style="display: flex; align-items: center">
                                  <div style="color: rgb(216, 153, 28)">
                                    {{ countryProducts.products.product1 }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-md-3"
                            v-if="hasAgo"
                            :class="salesTargetCount"
                          >
                            <div class="row align-items-center">
                              <div class="col-md-3">
                                <div
                                  style="
                                    height: 10px;
                                    width: 30px;
                                    background: rgb(155, 242, 36);
                                  "
                                ></div>
                              </div>
                              <div class="col-md-6">
                                <div style="display: flex; align-items: center">
                                  <div style="color: rgb(155, 242, 36)">
                                    {{ countryProducts.products.product2 }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-md-3"
                            v-if="hasDpk"
                            :class="salesTargetCount"
                          >
                            <div class="row align-items-center">
                              <div class="col-md-3">
                                <div
                                  style="
                                    height: 10px;
                                    width: 30px;
                                    background: rgb(0, 172, 237);
                                  "
                                ></div>
                              </div>
                              <div class="col-md-6">
                                <div style="display: flex; align-items: center">
                                  <div style="color: rgb(0, 172, 237)">
                                    {{ countryProducts.products.product3 }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-md-3"
                            v-if="hasLpg"
                            :class="salesTargetCount"
                          >
                            <div class="row align-items-center">
                              <div class="col-md-3">
                                <div
                                  style="
                                    height: 10px;
                                    width: 30px;
                                    background: purple;
                                  "
                                ></div>
                              </div>
                              <div class="col-md-6">
                                <div style="display: flex; align-items: center">
                                  <div style="color: purple">
                                    {{ countryProducts.products.product4 }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-sm-12 mt-5 drivers_block spread">
              <div
                class="row remove_padding mobile_tiles"
                style="height: 31.4%; margin-top: -12px"
              >
                <div
                  class="pl-3 text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
                >
                  <router-link
                    :to="{
                      name: 'our_dealers',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.dealers") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ dealers }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>

                <div
                  class="text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_left_desk"
                >
                  <router-link
                    :to="{
                      name: 'our_branches',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.stations") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ branches }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>

              <div
                class="row remove_padding mobile_tiles"
                style="height: 31.4%"
              >
                <div
                  class="pl-3 text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
                >
                  <router-link
                    :to="{
                      name: 'tanks_filled',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.productDischarged") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ tanksFilled }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>

                <div
                  class="text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_left_desk"
                  style="cursor: context-menu !important"
                >
                  <div
                    class="py-3 section_3_right_column_block new_tiles nohover"
                  >
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.cDashboard.totalPumps") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ pumpCount }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row remove_padding mobile_tiles"
                style="height: 31.4%"
              >
                <div
                  class="pl-3 text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
                >
                  <router-link
                    :to="{
                      name: 'disconnectedPumps',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.disconnectedPumps") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ offlinePumps }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>

                <div
                  class="text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_left_desk"
                >
                  <router-link
                    :to="{
                      name: 'offlinePumps',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.offlinePumps") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ deviceNotPushing }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>

              <!-- Transaction Count -->
              <div
                class="row remove_padding mobile_tiles"
                style="height: 18.4%"
              >
                <div
                  class="pl-3 text-center col-12 text_div_block lnk mobile_under_tile padding_right_desk"
                >
                  <!-- <div class="py-3 section_3_right_column_block new_tiles">
										<div class="">
											<h3 class="mt-1 stations__block_text_1 mobile_title_font">
												Transaction Count
											</h3>
										</div>
										<div class="">
											<h3
												class="stations__block_text_1 mobile_font"
												style="font-size: 40px"
											>
												{{ transaction_count }}
											</h3>
										</div>
									</div> -->

                  <router-link
                    :to="{
                      name: 'transaction_count',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.transactionCount") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ transaction_count.toLocaleString() }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- OLD DASHBOARD ENDS -->

        <!-- NEW DASHBOARD STARTS HERE -->
        <section v-else class="mt-5 section_3 last__ten__transactions__row">
          <div class="row mb-3" style="margin-top: -10px">
            <div class="col-md-12 col-lg-7 table_block">
              <!-- TOTAL TANKS CONSUMPTION REPORT -->
              <h5
                style="
                  font-size: 1.1rem;
                  margin-bottom: -5px;
                  padding-left: 10px;
                "
              >
                <span
                  v-if="
                    hasTankStockPms ||
                    hasTankStockAgo ||
                    hasTankStockDpk ||
                    hasTankStockLpg
                  "
                >
                  {{ $t("text.cDashboard.productInventory") }}
                </span>
              </h5>
              <div
                class="row mb-2 pos_trans_card_holder mb-3"
                v-if="!showLoader"
              >
                <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="[LGgridNum, MDgridNum]"
                  v-if="hasTankStockPms"
                >
                  <div
                    class="card_container_1 pos-card mt-3 card-vertical-center"
                  >
                    <h4 class="stations_card_header">
                      {{ countryProducts.products.product1 }}
                    </h4>
                    <div class="oil_drop_div_1">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h4 style="font-size: 1.3rem">
                        {{ convertThousand(pmsTankStock.volume)
                        }}{{ $t("text.cDisconnectedPumps.ltrs") }}
                      </h4>
                    </div>
                  </div>
                </div>

                <!-- NO PMS N/A -->
                <!-- <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="
                  v-if="!hasTankStockPms"
                >
                  <div
                    class="
                      card_container_greyed
                      pos-card
                      mt-3
                      card-vertical-center
                    "
                  >
                    <h5 class="stations_card_header disabled-text">PMS</h5>
                    <div class="oil_drop_div_1 disabled-label-bg">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h5 class="">N/A</h5>
                    </div>
                  </div>
                </div> -->
                <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="[LGgridNum, MDgridNum]"
                  v-if="hasTankStockAgo"
                >
                  <div
                    class="card_container_1 pos-card mt-3 card-vertical-center"
                  >
                    <h5 class="stations_card_header_1">
                      {{ countryProducts.products.product2 }}
                    </h5>
                    <div class="oil_drop_div_2">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h4 style="font-size: 1.3rem">
                        {{ convertThousand(agoTankStock.volume)
                        }}{{ $t("text.cDisconnectedPumps.ltrs") }}
                      </h4>
                    </div>
                  </div>
                </div>

                <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="[LGgridNum, MDgridNum]"
                  v-if="hasTankStockDpk"
                >
                  <div
                    class="card_container_1 pos-card mt-3 card-vertical-center"
                  >
                    <h4 class="stations_card_header_2">
                      {{ countryProducts.products.product3 }}
                    </h4>
                    <div class="oil_drop_div_3">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h4 style="font-size: 1.3rem">
                        {{ convertThousand(dpkTankStock.volume)
                        }}{{ $t("text.cDisconnectedPumps.ltrs") }}
                      </h4>
                    </div>
                  </div>
                </div>

                <!-- NO DPK N/A -->
                <!-- <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="
                  v-if="!hasTankStockDpk"
                >
                  <div
                    class="
                      card_container_greyed
                      pos-card
                      mt-3
                      card-vertical-center
                    "
                  >
                    <h5 class="stations_card_header disabled-text">DPK</h5>
                    <div class="oil_drop_div_1 disabled-label-bg">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h5 class="">N/A</h5>
                    </div>
                  </div>
                </div> -->

                <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="[LGgridNum, MDgridNum]"
                  v-if="hasTankStockLpg"
                >
                  <div
                    class="card_container_1 pos-card mt-3 card-vertical-center"
                  >
                    <h4 class="stations_card_header_1" style="color: purple">
                      {{ countryProducts.products.product4 }}
                    </h4>
                    <div class="oil_drop_div_4" style="background: purple">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h4 style="font-size: 1.3rem">
                        {{ convertThousand(lpgTankStock.volume)
                        }}{{ $t("text.cDisconnectedPumps.kg") }}
                      </h4>
                      <small class="dashboard__card__header_bottom"> </small>
                    </div>
                  </div>
                </div>

                <!-- NO LPG N/A -->
                <!-- <div
                  class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                  :class="productCount"
                  v-if="!hasTankStockLpg"
                >
                  <div
                    class="
                      card_container_greyed
                      pos-card
                      mt-3
                      card-vertical-center
                    "
                  >
                    <h5 class="stations_card_header disabled-text">LPG</h5>
                    <div class="oil_drop_div_1 disabled-label-bg">
                      <div class="text-center">
                        <img
                          src="@/assets/img/drop-of-liquid.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <h5 class="">N/A</h5>
                    </div>
                  </div>
                </div> -->
              </div>

              <!-- REVENUE AND PAYMENT CHANNEL TABLE -->
              <div
                class="section_3_table_section mt-3"
                style="
                  border: 3px solid #ae91d3;
                  border-radius: 10px;
                  background-color: #fcfcfc;
                  min-height: 510px !important;
                  height: 520px !important;
                  overflow: auto;
                  scrollbar-width: none;
                  -ms-overflow-style: none;
                "
              >
                <div class="row">
                  <div class="ml-2">
                    <ul class="tabs__lists d-flex justify-content-center">
                      <li class="ml-1" @click="changeTab('pchannel')">
                        <a
                          href="#0"
                          class="tab_link"
                          :class="[
                            tab === 'pchannel' ? 'active__tab__link' : null,
                          ]"
                          :style="[
                            tab === 'pchannel' ? { color: '#4C2E73' } : null,
                          ]"
                        >
                          {{ $t("text.omit.paymentChannel") }}
                        </a>
                      </li>

                      <li class="ml-3" @click="changeTab('revenue')">
                        <a
                          href="#0"
                          class="tab_link"
                          :class="[
                            tab === 'revenue' ? 'active__tab__link' : null,
                          ]"
                          :style="[
                            tab === 'revenue' ? { color: '#4C2E73' } : null,
                          ]"
                        >
                          {{ $t("text.omit.revenue") }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- NEW TABLE -->
                <div v-show="tab === 'pchannel'">
                  <table class="table table-hover">
                    <tbody>
                      <tr>
                        <!-- <tr
                        @click="openRouteInNewTab('company_wallet_topup')"
                        style="cursor: pointer"
                      > -->
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/desales.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          <!-- {{ $t("text.cMasterLayout.retainership") }} -->
                          {{ $t("text.omit.walletTU") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT"
                          ></pulse-loader>
                          <span v-else> {{ pccurrency }}{{ pcWalletTU }} </span>
                        </td>
                      </tr>
                      <tr
                        @click="openRouteInNewTab('company_POS')"
                        style="cursor: pointer"
                      >
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/dpossales.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          {{ $t("text.sales.posSales") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT"
                          ></pulse-loader>
                          <span v-else> {{ pccurrency }}{{ pcposSales }} </span>
                        </td>
                      </tr>
                      <tr
                        @click="openRouteInNewTab('companyRetainershipSales')"
                        style="cursor: pointer"
                      >
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/desales.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          <!-- {{ $t("text.cMasterLayout.retainership") }} -->
                          {{ $t("text.sales.retainerSales") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT"
                          ></pulse-loader>
                          <span v-else>
                            {{ pccurrency }}{{ pcretainership }}
                          </span>
                        </td>
                      </tr>
                      <tr
                        @click="openRouteInNewTab('CompanyEsales')"
                        style="cursor: pointer"
                      >
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/desales.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          {{ $t("text.omit.remisSales") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT"
                          ></pulse-loader>
                          <span v-else> {{ pccurrency }}{{ pcesales }} </span>
                        </td>
                      </tr>
                      <tr
                        @click="openRouteInNewTab('company_cash_flow')"
                        style="cursor: pointer"
                      >
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/dcash.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          {{ $t("text.bExpenses.cash") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT"
                          ></pulse-loader>
                          <span v-else> {{ pccurrency }}{{ pccash }} </span>
                        </td>
                      </tr>
                      <tr
                        @click="showBank = !showBank"
                        style="cursor: pointer"
                        @mouseenter="hoverWT = true"
                        @mouseleave="hoverWT = false"
                        :style="[
                          hoverWT ? { backgroundColor: '#e9ecef' } : null,
                        ]"
                      >
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/dbankdep.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          {{ $t("text.bMasterLayout.bankDeposits") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT"
                          ></pulse-loader>
                          <span v-else>
                            {{ pccurrency }}{{ pcbankDeposit }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- TABLE UNDER BANK DEPOSIT -->
                  <transition name="slide-down" appear>
                    <div
                      @click="openRouteInNewTab('bank-linked-transactions')"
                      @mouseenter="hoverWT = true"
                      @mouseleave="hoverWT = false"
                      v-if="showBank"
                      class="row m-auto text-uppercase"
                      :style="[hoverWT ? { backgroundColor: '#e9ecef' } : null]"
                      style="
                        color: #667084;
                        font-size: 12px;
                        margin-top: -20px !important;
                        cursor: pointer;
                      "
                    >
                      <div class="col-2 d-flex justify-content-end">
                        <img
                          src="@/assets/img/dtablines.png"
                          width="10px"
                          height="100px"
                          class="mr-2 ml-2"
                        />
                      </div>
                      <div class="col-10 mt-3">
                        <div class="d-flex justify-content-between">
                          <div>
                            <p>{{ $t("text.omit.payDirect") }}:</p>
                          </div>
                          <hr
                            class="mt-2"
                            style="
                              border-bottom: 2px dashed #c8ccd3;
                              max-width: 250px;
                              min-width: 40px;
                            "
                          />
                          <div class="mr-2">
                            <pulse-loader
                              size="15px"
                              v-if="loadingNT2"
                            ></pulse-loader>
                            <p v-else>
                              {{ pccurrency }}{{ pcpayDirectBankDeposit }}
                            </p>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between">
                          <div>
                            <p>{{ $t("text.omit.directTransfer") }}:</p>
                          </div>
                          <hr
                            class="mt-2"
                            style="
                              border-bottom: 2px dashed #c8ccd3;
                              max-width: 250px;
                              min-width: 40px;
                            "
                          />
                          <div class="mr-2">
                            <pulse-loader
                              size="15px"
                              v-if="loadingNT2"
                            ></pulse-loader>
                            <p v-else>
                              {{ pccurrency }}{{ pcdirectBankDeposit }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>

                  <P class="text-left"
                    ><span class="text-danger">**</span
                    ><span v-if="dateRange.start !== dateRange.end">
                      {{ $t("text.sales.outstandingCash") }}
                      {{ $t("text.calendar.from") }} ({{
                        $moment(dateRange.start, "DD-MM-YYYY").format(
                          "MMMM D, YYYY"
                        )
                      }}
                      -
                      {{
                        $moment(dateRange.end, "DD-MM-YYYY").format(
                          "MMMM D, YYYY"
                        )
                      }}) {{ $t("text.omit.is") }}</span
                    >
                    <span v-else>
                      {{ $t("text.sales.outstandingCash") }}
                      {{ $t("text.for.text") }} ({{
                        $moment(dateRange.start, "DD-MM-YYYY").format(
                          "MMMM D, YYYY"
                        )
                      }}) {{ $t("text.omit.is") }}</span
                    >
                    <pulse-loader
                      style="display: inline"
                      size="15px"
                      v-if="loadingNT"
                    ></pulse-loader>
                    <span v-else class="font-weight-bold"
                      >{{ pccurrency }}{{ pcoutstandingCash }}</span
                    ></P
                  >
                </div>
                <div v-show="tab === 'revenue'">
                  <table class="table table-hover mt-4">
                    <tbody>
                      <tr
                        @click="openRouteInNewTab('NonWetProducts')"
                        style="cursor: pointer"
                      >
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/dstock.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          {{ $t("text.cusMasterLayout.dryStock") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <span v-else>
                            {{ pccurrency2 }}{{ convertThousand(pcdryStock) }}
                          </span>
                        </td>
                      </tr>
                      <tr
                        @click="openRouteInNewTab('non-wet-product-Sales')"
                        style="cursor: pointer"
                        class=""
                        @mouseenter="hoverWT = true"
                        @mouseleave="hoverWT = false"
                        :style="[
                          hoverWT ? { backgroundColor: '#e9ecef' } : null,
                        ]"
                      >
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/dstock.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          {{ $t("text.omit.wetStock") }}
                          <!-- <span class="ml-3" style="cursor: pointer">
                            <i class="fa fa-angle-down sidenav_arrow"></i>
                          </span> -->
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <span v-else>
                            {{ pccurrency2 }}{{ convertThousand(pcwetStock) }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- TABLE UNDER WET STOCK -->
                  <div
                    @click="openRouteInNewTab('NonWetProducts')"
                    @mouseenter="hoverWT = true"
                    @mouseleave="hoverWT = false"
                    class="row m-auto text-uppercase"
                    :style="[hoverWT ? { backgroundColor: '#e9ecef' } : null]"
                    style="
                      color: #667084;
                      font-size: 12px;
                      margin-top: -20px !important;
                      cursor: pointer;
                    "
                  >
                    <div class="col-2 d-flex justify-content-end">
                      <img
                        src="@/assets/img/dtablines.png"
                        width="10px"
                        height="100px"
                        class="mr-2 ml-2"
                      />
                    </div>
                    <div class="col-10 mt-3">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p>{{ $t("text.omit.dispensed") }}:</p>
                        </div>
                        <hr
                          class="mt-2"
                          style="
                            border-bottom: 2px dashed #c8ccd3;
                            max-width: 250px;
                            min-width: 40px;
                          "
                        />
                        <div class="mr-2">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <p v-else>
                            {{ pccurrency2 }}{{ convertThousand(pcbalance) }}
                          </p>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between">
                        <div>
                          <p>{{ $t("text.omit.rtt") }}:</p>
                        </div>
                        <hr
                          class="mt-2"
                          style="
                            border-bottom: 2px dashed #c8ccd3;
                            max-width: 250px;
                            min-width: 40px;
                          "
                        />
                        <div class="mr-2">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <p v-else>
                            {{ pccurrency2 }}{{ convertThousand(pcrtt) }}
                          </p>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between">
                        <div>
                          <p>{{ $t("text.cMasterLayout.sales") }}:</p>
                        </div>
                        <hr
                          class="mt-2"
                          style="
                            border-bottom: 2px dashed #c8ccd3;
                            max-width: 250px;
                            min-width: 40px;
                          "
                        />
                        <div class="mr-2">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <p v-else>
                            {{ pccurrency2
                            }}{{ convertThousand(pcbalance - pcrtt) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <table class="table table-hover">
                    <tbody>
                      <tr
                        @click="openRouteInNewTab('company_expenses')"
                        style="cursor: pointer"
                      >
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/dexpenses.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          {{ $t("text.cMasterLayout.expenses") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <span v-else>
                            {{ pccurrency2 }}{{ convertThousand(pcexpenses) }}
                          </span>
                        </td>
                      </tr>
                      <tr class="font-weight-bold">
                        <td class="pl-4 text-uppercase d-flex">
                          <span>
                            <img
                              src="@/assets/img/dcash.png"
                              width="20px"
                              class="mr-2"
                            />
                          </span>
                          {{ $t("text.balance.title") }}
                        </td>
                        <td class="text-right pr-4">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <span v-else style="color: #4c2e73">
                            {{ pccurrency2
                            }}{{
                              convertThousand(
                                pcdryStock + pcwetStock - pcexpenses
                              )
                            }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-lg-5 col-sm-12 drivers_block spread">
              <!-- NEW SALES VS TARGET GRAPH HERE -->
              <h5 class="mb-4 ml-4 mobMarg" style="font-size: 1.1rem">
                {{ $t("text.bDashboard.salesVTarget") }}
              </h5>

              <div
                class="remove_padding mobile_tiles"
                style="margin-top: -12px"
              >
                <div
                  class="mb-3 text-center col-md-12 col-sm-12 text_div_block lnk padding_right_desk"
                >
                  <div class="py-4 section_3_right_column_block new_tiles">
                    <div class="">
                      <!-- <h3
                        class="mt-1 stations__block_text_1 mobile_title_font col-5"
                      >
                        {{ $t("text.bDashboard.salesVTarget") }}
                      </h3> -->
                      <div class="highcharts__div">
                        <highcharts
                          :options="NewSalesTarget"
                          class=""
                        ></highcharts>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- GRAPH SALES VS TARGET ENDS HERE -->
              <div
                class="row remove_padding mobile_tiles boxMarg"
                style="height: 37.4%; margin-top: 150px"
              >
                <div
                  class="pl-3 text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
                >
                  <router-link
                    :to="{
                      name: 'our_dealers',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.dealers") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ dealers }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>

                <div
                  class="text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_left_desk"
                >
                  <router-link
                    :to="{
                      name: 'our_branches',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.stations") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ branches }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>

              <div
                class="row remove_padding mobile_tiles mt-4"
                style="height: 31.4%"
              >
                <div
                  class="pl-3 text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
                >
                  <router-link
                    :to="{
                      name: 'tanks_filled',
                      query: { companyId: $route.query.companyId },
                    }"
                    class="router_link__text"
                  >
                    <div class="py-3 section_3_right_column_block new_tiles">
                      <div class="">
                        <h3
                          class="mt-1 stations__block_text_1 mobile_title_font"
                        >
                          {{ $t("text.cDashboard.productDischarged") }}
                        </h3>
                      </div>
                      <div class="">
                        <h3
                          class="stations__block_text_1 mobile_font"
                          style="font-size: 40px"
                        >
                          {{ tanksFilled }}
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>

                <div
                  class="text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_left_desk"
                  style="cursor: context-menu !important"
                >
                  <div
                    class="py-3 section_3_right_column_block new_tiles nohover"
                  >
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.cDashboard.totalPumps") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ pumpCount }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mobile_marg_ri">
            <!-- DISCONNECTED PUMPS -->
            <div
              class="col-lg-4 col-sm-12 remove_padding"
              style="height: 18.4%"
            >
              <div
                class="text-center text_div_block lnk mobile_under_tile padding_right_desk"
              >
                <router-link
                  :to="{
                    name: 'disconnectedPumps',
                    query: { companyId: $route.query.companyId },
                  }"
                  class="router_link__text"
                >
                  <div class="py-3 section_3_right_column_block new_tiles">
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.cDashboard.disconnectedPumps") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ offlinePumps }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <!-- OFFLINE PUMPS -->
            <div
              class="col-lg-4 col-sm-12 remove_padding"
              style="height: 18.4%"
            >
              <div
                class="text-center text_div_block lnk mobile_under_tile padding_right_desk"
              >
                <router-link
                  :to="{
                    name: 'offlinePumps',
                    query: { companyId: $route.query.companyId },
                  }"
                  class="router_link__text"
                >
                  <div class="py-3 section_3_right_column_block new_tiles">
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.cDashboard.offlinePumps") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ deviceNotPushing }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <!-- TRANSACTION COUNT -->
            <div
              class="col-lg-4 col-sm-12 remove_padding"
              style="height: 18.4%"
            >
              <div
                class="text-center text_div_block lnk mobile_under_tile padding_right_desk"
              >
                <router-link
                  :to="{
                    name: 'transaction_count',
                    query: { companyId: $route.query.companyId },
                  }"
                  class="router_link__text"
                >
                  <div class="py-3 section_3_right_column_block new_tiles">
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.cDashboard.transactionCount") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ transaction_count.toLocaleString() }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </section>
        <!-- NEW DASHBOARD ENDS HERE -->

        <section class="mt-3 tanks__capacity">
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="tank_capacity__header">
              <span>
                <img src="@/assets/img/Group 553.png" class="mr-2" />
              </span>
              {{ $t("text.cDashboard.tankStockProjection") }}
            </h3>
          </div>
          <hr />
          <pulse-loader
            size="15px"
            v-if="showLoader"
            class="py-5"
          ></pulse-loader>
          <div class="mt-5">
            <div
              class="text-center no-tank"
              v-if="showLoader || lowTanks.length < 1"
            >
              {{ $t("text.cDashboard.noLowTanks") }}
            </div>

            <vueper-slides
              class="no-shadow"
              :visible-slides="4"
              slide-multiple
              :gap="0"
              :slide-ratio="1 / 4"
              :dragging-distance="200"
              :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }"
            >
              <vueper-slide
                v-show="index <= 3 || showAll"
                v-for="(lowTank, index) in lowTanks"
                :key="index"
                style="
                  display: block !important;
                  padding-right: 0;
                  padding-left: 0;
                "
              >
                <template v-slot:content>
                  <router-link
                    :to="{
                      name: 'company-sufficiency',
                      query: {
                        companyId: lowTank.companyId,
                      },
                    }"
                  >
                    <div class="text-center low_tank">
                      <h4 class="tank__name__header low_tank_name">
                        {{ lowTank.name }}
                      </h4>
                      <p style="margin-bottom: 0 !important" class="max-lines">
                        {{ lowTank.branchName }} ({{ lowTank.product }})
                      </p>
                      <!-- <span>
											{{ lowTank.lastDate }}
										</span> -->
                      <div class="animated__tanks__div">
                        <div class="bowl" style="margin-left: 25%">
                          <div class="inner">
                            <div
                              class="fill"
                              v-bind:style="{
                                '--h': lowTank.height + 'px',
                                '--c': lowTank.color,
                              }"
                            >
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="300px"
                                height="300px"
                                viewBox="0 0 300 300"
                                enable-background="new 0 0 300 300"
                                xml:space="preserve"
                              >
                                <path
                                  class="waveShape"
                                  d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                                                          c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                                                          c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="clearfix mt-3">
                        <div class="left_div">
                          <span class="left"
                            >{{ $t("text.cDashboard.curVolume") }}:</span
                          >
                        </div>
                        <div class="right_div">
                          <span class="litres">
                            {{ convertThousand(lowTank.currentVolume) }} ({{
                              lowTank.percent
                            }}%)
                          </span>
                        </div>
                      </div>
                      <div class="clearfix mt-2">
                        <div class="left_div">
                          <span class="left"
                            >{{ $t("text.cDashboard.maxVolume") }}:</span
                          >
                        </div>
                        <div class="right_div">
                          <span class="litres">
                            {{ convertThousand(lowTank.maxCapacity) }}
                          </span>
                        </div>
                      </div>
                      <div class="clearfix mt-2">
                        <div class="left_div">
                          <div class="left">
                            <span title="Sales prediction in the next 48 hours"
                              >{{
                                $t("text.cDashboard.salesProjection")
                              }}:</span
                            >
                          </div>
                        </div>
                        <div class="right_div">
                          <span class="litres">
                            {{ lowTank.nextTwoDaysTankSales.toLocaleString() }}
                          </span>
                        </div>
                      </div>

                      <div class="clearfix mt-2">
                        <div class="left_div">
                          <div class="left">
                            <span title="Volume prediction in the next 48 hours"
                              >{{ $t("text.cDashboard.volProjection") }}:</span
                            >
                          </div>
                        </div>
                        <div class="right_div">
                          <span class="litres">
                            {{ lowTank.nextTwoDaysTankVolume }}
                          </span>
                        </div>
                      </div>

                      <!-- <div class="clearfix pb-4 mt-2">
											<div class="left_div">
												<span class="left"> Tank empty projection:</span>
											</div>
											<div class="right_div">
												<span class="litres" style="font-size: 13px">
													{{ convertThousand(lowTank.tankEmptyProjectionDate) }}
												</span>
											</div>
										</div> -->
                    </div>
                  </router-link>
                </template>
              </vueper-slide>
            </vueper-slides>
          </div>
        </section>
        <section>
          <div class="mt-3 section__row">
            <div class="">
              <div class="row top_section_row">
                <div class="col-md-8">
                  <span class="sec_text_color">
                    <img src="@/assets/img/hand (1).png" class="mr-3" />
                    {{ $t("text.cDashboard.todaySalesTransactions") }}
                    <span v-if="dateRange.start !== dateRange.end"
                      >({{
                        $moment(dateRange.start, "DD-MM-YYYY").format(
                          "MMMM D, YYYY"
                        )
                      }}
                      -
                      {{
                        $moment(dateRange.end, "DD-MM-YYYY").format(
                          "MMMM D, YYYY"
                        )
                      }})</span
                    >
                    <span v-else
                      >({{
                        $moment(dateRange.start, "DD-MM-YYYY").format(
                          "MMMM D, YYYY"
                        )
                      }})</span
                    >
                    <!-- ({{
                      $d(new Date(), "short", this.$root.$i18n.locale)
                    }}) -->
                  </span>
                </div>
                <div class="text-right col-md-4">
                  <div class="">
                    <!-- <button class="view_more___button">View More</button> -->
                  </div>
                </div>
              </div>

              <div>
                <ejs-grid
                  v-show="!showLoader"
                  ref="dataGrid"
                  :dataBound="dataBound"
                  :created="refreshGrid"
                  :allowPaging="true"
                  :allowSorting="true"
                  :pageSettings="pageSettings"
                  :toolbar="toolbar"
                  :searchSettings="search"
                  :allowExcelExport="true"
                  :allowPdfExport="true"
                  :toolbarClick="toolbarClick"
                  :locale="usedLang"
                >
                  <e-columns>
                    <e-column
                      width="60"
                      field="index"
                      headerText="#"
                    ></e-column>

                    <e-column
                      field="branchName"
                      width="200"
                      v-if="!hasGroup"
                      :headerText="$t('text.cDashboard.station')"
                    ></e-column>

                    <e-column
                      field="state"
                      width="200"
                      :headerText="$t('text.cDashboard.state')"
                      v-if="!hasGroup"
                    ></e-column>

                    <e-column
                      field="region"
                      width="280"
                      v-if="hasGroup"
                      :headerText="$t('text.cDashboard.region')"
                    ></e-column>
                    <e-column
                      :visible="hasPms ? true : false"
                      field="pmsVolume"
                      width="200"
                      format="N2"
                      :headerText="`${countryProducts.products.product1} ${$t(
                        'text.cDashboard.productVolume'
                      )}`"
                    ></e-column>
                    <e-column
                      :visible="hasPms ? true : false"
                      field="pmsAmount"
                      width="200"
                      format="N2"
                      :headerText="`${countryProducts.products.product1}  
					  ${$t('text.cDashboard.productAmount', {
              currency: `(${company ? company.currency : ''})`,
            })}`"
                    ></e-column>
                    <e-column
                      :visible="hasAgo ? true : false"
                      field="agoVolume"
                      width="200"
                      format="N2"
                      :headerText="`${countryProducts.products.product2} ${$t(
                        'text.cDashboard.productVolume'
                      )}`"
                    ></e-column>
                    <e-column
                      :visible="hasAgo ? true : false"
                      field="agoAmount"
                      width="200"
                      format="N2"
                      :headerText="`${countryProducts.products.product2} ${$t(
                        'text.cDashboard.productAmount',
                        {
                          currency: `(${company ? company.currency : ''})`,
                        }
                      )}`"
                    ></e-column>
                    <e-column
                      :visible="hasDpk ? true : false"
                      field="dpkVolume"
                      width="200"
                      format="N2"
                      :headerText="`${countryProducts.products.product3} ${$t(
                        'text.cDashboard.productVolume'
                      )}`"
                    ></e-column>
                    <e-column
                      :visible="hasDpk ? true : false"
                      field="dpkAmount"
                      width="200"
                      format="N2"
                      :headerText="`${countryProducts.products.product3} ${$t(
                        'text.cDashboard.productAmount',
                        {
                          currency: `(${company ? company.currency : ''})`,
                        }
                      )}`"
                    ></e-column>
                    <e-column
                      :visible="hasLpg ? true : false"
                      field="lpgVolume"
                      width="200"
                      format="N2"
                      :headerText="`${countryProducts.products.product4} ${$t(
                        'text.cDashboard.productVolume'
                      )}`"
                    ></e-column>
                    <e-column
                      :visible="hasLpg ? true : false"
                      field="lpgAmount"
                      width="200"
                      format="N2"
                      :headerText="`${countryProducts.products.product4} ${$t(
                        'text.cDashboard.productAmount',
                        {
                          currency: `(${company ? company.currency : ''})`,
                        }
                      )}`"
                    ></e-column>
                    <e-column
                      field="totalAmount"
                      width="200"
                      format="N2"
                      :headerText="
                        $t('text.cDashboard.total', {
                          currency: `(${company ? company.currency : ''})`,
                        })
                      "
                    ></e-column>

                    <e-column
                      :headerText="$t('text.actionButtons.title')"
                      width="200"
                      v-if="hasGroup"
                      textAlign="Center"
                      :template="actionButton"
                    ></e-column>
                  </e-columns>
                </ejs-grid>
              </div>
              <TableLoader :showLoader="showLoader"></TableLoader>
            </div>
          </div>
        </section>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import JQuery from "jquery";
import TableLoader from "@/components/tableLoader/index";
import UpdateCompanyDomain from "@/components/modals/CompanyDomain/index";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import countryProducts from "@/products";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

let $ = JQuery;
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

// import { L10n, setCulture } from "@syncfusion/ej2-base";

// setCulture("fr");

// L10n.load({
//   fr: {
//     grid: {
//       EmptyRecord: "Onwero if di eba",
//       GroupDropArea:
//         "Ziehen Sie einen Spaltenkopf hier, um die Gruppe ihre Spalte",
//       UnGroup: "Klicken Sie hier, um die Gruppierung aufheben",
//       EmptyDataSourceError:
//         "DataSource darf bei der Erstauslastung nicht leer sein, da Spalten aus der dataSource im AutoGenerate Spaltenraster",
//       Item: "Artikel",
//       Items: "Artikel",
//       Pdfexport: "Nke Peedi ef",
//       Excelexport: "Nke Excelu",
//       Search: "Cho Ya",
//     },
//     pager: {
//       pagerDropDown: "Lekwa nka",
//       currentPageInfo: "{0} von {1} Seiten",
//       totalItemsInfo: "({0} Beiträge)",
//       firstPageTooltip: "Zur ersten Seite",
//       lastPageTooltip: "Zur letzten Seite",
//       nextPageTooltip: "Zur nächsten Seite",
//       previousPageTooltip: "Zurück zur letzten Seit",
//       nextPagerTooltip: "Gehen Sie zu den nächsten Pager-Elementen",
//       previousPagerTooltip: "Gehen Sie zu vorherigen Pager-Elementen",
//     },
//   },
// });

// Vue.use(GridPlugin);

export default {
  title: "Company Dashboard :: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    TableLoader,
    UpdateCompanyDomain,
    VueperSlides,
    VueperSlide,
    PulseLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      tankRate: 100,
      isIncrease: true,
      startDate: this.$moment().subtract(0, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(0, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      transactionCountStartDate: this.$moment()
        .subtract(1, "days")
        .format("MMMM D, YYYY"),
      transactionCountEndDate: this.$moment().format("MMMM D, YYYY"),
      company: null,
      LGgridNum: "",
      MDgridNum: "",
      transaction_count: 0,
      hasGroup: null,

      usedLang: this.$store.getters.getLanguage,

      actionButton: function () {
        return {
          template: Vue.component("columntemplate", {
            template: `  <div >
									<button @click='routeRegion(data)' style='background-color: #370f70;
									color: white;
									padding: 10px 20px;
									border: none;
									border-radius: 5px;' >{{ $t("text.clickButtons.viewDetails") }}</button>
									</div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              routeRegion(data) {
                this.$eventHub.$emit("routeToRegionPage", data);
              },
            },
          }),
        };
      },

      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      getting: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 50,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      branches: 0,
      tanksFilled: 0,
      // company: localStorage.getItem("companyDetails")
      //   ? JSON.parse(localStorage.getItem("companyDetails"))
      //   : null,
      dealers: 0,
      pumpCount: 0,
      todaysDate: new Date(),
      offlinePumps: 0,
      deviceNotPushing: 0,
      availableProducts: [],
      agoRateColor: "",
      pmsRateColor: "",
      dpkRateColor: "",
      pgRateColor: "",
      totalRateColor: "",
      agoUp: true,
      dpkUp: true,
      pmsUp: true,
      lpgUp: true,
      totalUp: true,
      showLoader: true,
      showAll: false,
      lowTanks: [],
      hasTankStockLpg: false,
      hasTankStockPms: false,
      hasTankStockAgo: false,
      hasTankStockDpk: false,
      hasLpg: false,
      hasPms: false,
      hasAgo: false,
      hasDpk: false,
      pmsRate: 0,
      agoRate: 0,
      dpkRate: 0,
      lpgRate: 0,
      totalRate: 0,
      pmssalesTarget: 0,
      agosalesTarget: 0,
      dpksalesTarget: 0,
      lpgsalesTarget: 0,
      currentBranchId: null,
      pmsSale: 0,
      agoSale: 0,
      dpkSale: 0,
      lpgSale: 0,
      //  "col-lg-3",
      productCount: "col-lg-3",
      prodCounts: 0,
      salesTargetCount: "col-lg-4",
      productSummary: [],
      pmsSummary: { volume: 0, amount: 0 },
      agoSummary: { volume: 0, amount: 0 },
      dpkSummary: { volume: 0, amount: 0 },
      lpgSummary: { volume: 0, amount: 0 },
      pmsTankStock: { volume: 0, amount: 0 },
      agoTankStock: { volume: 0, amount: 0 },
      dpkTankStock: { volume: 0, amount: 0 },
      lpgTankStock: { volume: 0, amount: 0 },
      availableProducts: [],
      targetsProd: [],
      interval: null,

      hoverWT: false,
      showBank: false,

      pmsCond: false,
      agoCond: false,
      dpkCond: false,
      lpgCond: false,
      tab: "pchannel",

      pcbankDeposit: 0,
      pcdirectBankDeposit: 0,
      pcpayDirectBankDeposit: 0,
      pccash: 0,
      pccurrency: "",
      pcesales: 0,
      pcWalletTU: 0,
      pcretainership: 0,
      pcoutstandingCash: 0,
      pcposSales: 0,
      pcbalance: 0,
      pcdryStock: 0,
      pcexpenses: 0,
      pcwetStock: 0,
      pcrtt: 0,
      pccurrency2: "",
      loadingNT: true,
      loadingNT2: true,
      loadedFirst: false,
      NewSalesTarget: {
        chart: {
          height: "50%",
          type: "bar",
        },
        title: {
          text: undefined,
        },

        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: undefined,
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            maxPointWidth: 30,
            groupPadding: 0,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y:.1f}%",
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> <br/>',
        },

        series: [],
      },

      pmsGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "65%",
        },

        title: {
          text: "",
          style: {
            color: "#d8991c",
          },
        },

        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,

          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',

          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },

        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "rgb(254,228,179)",
              borderWidth: 0,
            },
          ],
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',

              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
          },
          linecap: "round",
          stickyTracking: false,
          rounded: false,
        },

        series: [
          {
            name: "",
            data: [
              {
                color: "#d8991c",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
                states: {
                  hover: {
                    enabled: false,
                  },
                },
              },
            ],
          },
        ],
      },
      agoGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "65%",
        },

        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "#0fce29",
          },
        },

        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
          states: {
            hover: {
              enabled: false,
            },
          },
        },

        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "rgb(231, 255, 200)",
              opacity: 0.3,
              borderWidth: 0,
            },
          ],
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',

              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
            linecap: "round",
            stickyTracking: false,
            rounded: false,
          },
        },

        series: [
          {
            name: "",
            data: [
              {
                color: "#0fce29",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
              },
            ],
          },
        ],
      },
      dpkGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "65%",
        },

        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "#00aced",
          },
        },

        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },

        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "rgb(207, 241, 254)",
              opacity: 0.3,
              borderWidth: 0,
            },
          ],
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',

              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
            linecap: "round",
            stickyTracking: false,
            rounded: false,
          },
        },

        series: [
          {
            name: "",
            data: [
              {
                color: "#00aced",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
              },
            ],
          },
        ],
      },
      lpgGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "65%",
          // style:{
          //    "fontSize": "12px !important",
          // }
        },

        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "rgb(233, 141, 233)",
          },
        },

        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },

        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "rgb(233, 141, 233)",
              opacity: 0.1,
              borderWidth: 0,
            },
          ],
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',

              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
            linecap: "round",
            stickyTracking: false,
            rounded: false,
          },
        },

        series: [
          {
            name: "",
            data: [
              {
                color: "#8000806b",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
              },
            ],
          },
        ],
      },
      greyedGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "85%",
        },

        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "#f5f5f5",
          },
        },

        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },

        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "#f5f5f5",
              opacity: 0.3,
              borderWidth: 0,
            },
          ],
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',

              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
            linecap: "round",
            stickyTracking: false,
            rounded: false,
          },
        },

        series: [
          {
            name: "",
            data: [
              {
                color: "#f5f5f5",
                radius: "112%",
                innerRadius: "88%",
                // y: 'N/A',
              },
            ],
          },
        ],
      },
      splineChartOptions: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      pmsSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      agoSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      dpkSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      lpgSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
          categories: null,
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      totalSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
    };
  },
  watch: {
    isIncrease: function () {
      this.getLowTanks();
    },
    tankRate: function () {
      this.getLowTanks();
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        // if (this.$route.query.companyId) {
        this.fetchData();
        this.getProductSummary();
        this.getSalesTarget();
        // }
      }
    },
    company(company) {
      if (company !== null) {
        this.branches = company.numberOfBranches;
        this.dealers = company.numberOfDealers;
        this.fetchData();
        this.getProductSummary();
        this.getSalesTarget();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.getHistoryChartsData();
    });

    this.$eventHub.$on("routeToRegionPage", (data) => {
      this.finalRegionRoute(data);
    });
    this.getTodaysDate();
    if (this.$route.query.companyId) {
      this.fetchData();
      this.getProductSummary();
      this.getSalesTarget();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  computed: {
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },

  mounted() {
    if (this.userInfo.email == "demonstration@gmail.com") {
      this.$router.push({
        name: "price_management",
        query: {
          companyId: this.$route.query.companyId,
        },
      });
    }

    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;
    // console.log(this.usedLang);

    if (this.$route.query.companyId) {
      this.$store.commit("setCompanyDetails", {
        id: this.$route.query.companyId,
      });
    }
    if (localStorage.getItem("userDetails")) {
      this.interval = setInterval(() => {
        this.getProductSummary();
        this.getSalesTarget();
        this.loadedFirst = true;
        this.getPaymentChannelsData();
        this.getRevenueData();
      }, 60000);
    }

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  beforeDestroy() {
    this.$eventHub.$off("gotCompany");
    clearInterval(this.interval);
  },

  methods: {
    changeTab(tab) {
      this.tab = tab;
    },
    arrowLeft() {
      const containerLeft = document.getElementById("scoll-pane");
      this.sideScroll(containerLeft, "left", 25, 150, 10);
    },
    arrowRight() {
      var containerRight = document.getElementById("scoll-pane");
      this.sideScroll(containerRight, "right", 25, 150, 10);
    },
    sideScroll(element, direction, speed, distance, step) {
      let scrollAmount = 0;
      var slideTimer = setInterval(function () {
        if (direction == "left") {
          element.scrollLeft -= step;
        } else {
          element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    },
    openRouteInNewTab(name) {
      const routeData = this.$router.resolve({
        name: name,
        query: {
          companyId: this.$route.query.companyId,
          startDate: this.startDate,
          endDate: this.endDate,
        },
      });

      // Open the route URL in a new tab
      window.open(routeData.href, "_blank");
    },

    fetchData() {
      this.getTankStock();
      this.getLowTanks();
      this.getPumpCount();
      this.getTanksFilled();
      this.getOfflinePmps();
      this.loadedFirst = false;
      this.getPaymentChannelsData();
      this.getRevenueData();
      this.getDeviceNotPushing();
      this.getCompanyBranchSales();
      this.getTransactionCount();
    },
    finalRegionRoute(data) {
      this.$router.push({
        name: "region-sales-report",
        query: {
          regionId: data.regionId,
          startDate: this.startDate,
          endDate: this.endDate,
          region: data.region,
        },
      });
    },
    goToTanksFilled($route, _id) {
      this.$router.push({
        path: $route,
        query: {
          id: _id,
        },
      });
    },
    getTodaysDate() {
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var today = new Date();
      let month = months[today.getMonth()];
      var dd = String(today.getDate()).padStart(2, "0");
      var yyyy = today.getFullYear();

      today = month + " " + " " + dd + "," + " " + yyyy;
      this.todaysDate = today;
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    changeRoute(route) {
      this.$router.push({
        name: route,
        query: {
          id: this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id,
        },
      });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    tankStockSummary(productSummary) {
      let productName = productSummary.map((tank) => {
        return tank.productName;
      });

      let finalProduct = new Set(productName);

      this.LGgridNum = `col-lg-${12 / finalProduct.size}`;
      this.MDgridNum = `col-md-${12 / finalProduct.size}`;
      let prodCount = 0;
      let summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "pms"
      );
      if (summary && summary.length > 0) {
        this.pmsTankStock = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasTankStockPms = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "ago"
      );
      if (summary && summary.length > 0) {
        this.agoTankStock = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasTankStockAgo = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "dpk"
      );
      if (summary && summary.length > 0) {
        this.dpkTankStock = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasTankStockDpk = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "lpg"
      );
      if (summary && summary.length > 0) {
        this.lpgTankStock = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasTankStockLpg = true;
        prodCount++;
      }
      prodCount++;
      let columnNumber;
      prodCount !== 5 ? (columnNumber = 12 / prodCount) : (columnNumber = 3);
      // console.log(prodCount);
      this.productCount = `col-lg-3`;
      // this.= `col-lg-${columnNumber}`;
      // this.productCount = `col-lg-${columnNumber}`;
    },
    displayProductSummary(prodSummary) {
      if (prodSummary.length > 0) {
        let productCounting = 0;
        let pmsSummary = prodSummary.filter(
          (prod) =>
            prod.product.toLowerCase() ==
            this.countryProducts.productsLower.product1
        );
        if (pmsSummary.length) {
          productCounting++;
          this.pmsSummary = pmsSummary[0];
          this.pmsSale = pmsSummary[0].volume;
        }
        let agoSummary = prodSummary.filter(
          (prod) =>
            prod.product.toLowerCase() ==
            this.countryProducts.productsLower.product2
        );
        if (agoSummary.length) {
          productCounting++;
          this.agoSummary = agoSummary[0];
          this.agoSale = agoSummary[0].volume;
        }
        let dpkSummary = prodSummary.filter(
          (prod) =>
            prod.product.toLowerCase() ==
            this.countryProducts.productsLower.product3
        );
        if (dpkSummary.length) {
          productCounting++;
          this.dpkSummary = dpkSummary[0];
          this.dpkSale = dpkSummary[0].volume;
        }
        let lpgSummary = prodSummary.filter(
          (prod) =>
            prod.product.toLowerCase() ==
            this.countryProducts.productsLower.product4
        );
        if (lpgSummary.length) {
          productCounting++;
          this.lpgSummary = lpgSummary[0];
          this.lpgSale = lpgSummary[0].volume;
        }

        this.prodCounts = productCounting;
        // console.log(this.prodCounts);

        // NEW SALES VS TARGET GRAPH
        let pmsSeries = pmsSummary.length
          ? [
              {
                name: this.countryProducts.products.product1,
                y: parseFloat(
                  this.decimalThousand(
                    (this.pmsSale / this.pmssalesTarget) * 100
                  )
                ),
                color: "#D8991C",
              },
            ]
          : [];
        let agoSeries = agoSummary.length
          ? [
              {
                name: this.countryProducts.products.product2,
                y: parseFloat(
                  this.decimalThousand(
                    (this.agoSale / this.agosalesTarget) * 100
                  )
                ),
                color: "#6CC066",
              },
            ]
          : [];
        let dpkSeries = dpkSummary.length
          ? [
              {
                name: this.countryProducts.products.product3,
                y: parseFloat(
                  this.decimalThousand(
                    (this.dpkSale / this.dpksalesTarget) * 100
                  )
                ),
                color: "#1864AB",
              },
            ]
          : [];
        let lpgSeries = lpgSummary.length
          ? [
              {
                name: this.countryProducts.products.product4,
                y: parseFloat(
                  this.decimalThousand(
                    (this.lpgSale / this.lpgsalesTarget) * 100
                  )
                ),
                color: "#820080",
              },
            ]
          : [];

        this.NewSalesTarget.series = [
          {
            name: "Product",
            data: [...pmsSeries, ...agoSeries, ...dpkSeries, ...lpgSeries],
          },
        ];

        let ps = parseFloat(
          this.decimalThousand((this.pmsSale / this.pmssalesTarget) * 100)
        );
        this.pmsGuageOptions.series[0].data[0].y = ps;

        let as = parseFloat(
          this.decimalThousand((this.agoSale / this.agosalesTarget) * 100)
        );
        this.agoGuageOptions.series[0].data[0].y = as;

        let ds = parseFloat(
          this.decimalThousand((this.dpkSale / this.dpksalesTarget) * 100)
        );
        this.dpkGuageOptions.series[0].data[0].y = ds;

        let ls = parseFloat(
          this.decimalThousand((this.lpgSale / this.lpgsalesTarget) * 100)
        );
        this.lpgGuageOptions.series[0].data[0].y = ls;
      }
    },
    getProductSummary() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/CompanyDaySale/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          const dayDifferences = {};

          response.data.forEach((item) => {
            const { product, volume, lastSalesDate, date } = item;

            // NEW CONDITIONAL FOR DISPLAYING FIRST CARD GRAPH
            const lastSales = new Date(lastSalesDate);
            const currentDate = new Date(date);
            const timeDifference = currentDate - lastSales;
            const daysDifference = Math.floor(
              timeDifference / (1000 * 60 * 60 * 24)
            );

            dayDifferences[product] = {
              daysDifference,
              volume,
            };
          });

          if (
            dayDifferences.PMS &&
            dayDifferences.PMS.daysDifference > 30 &&
            dayDifferences.PMS.volume == 0
          ) {
            // this.pmsCond = true;
          }
          if (
            dayDifferences.AGO &&
            dayDifferences.AGO.daysDifference > 30 &&
            dayDifferences.AGO.volume == 0
          ) {
            // this.agoCond = true;
          }
          if (
            dayDifferences.DPK &&
            dayDifferences.DPK.daysDifference > 30 &&
            dayDifferences.DPK.volume == 0
          ) {
            // this.dpkCond = true;
          }
          if (
            dayDifferences.LPG &&
            dayDifferences.LPG.daysDifference > 30 &&
            dayDifferences.LPG.volume == 0 &&
            this.prodCounts == 4
          ) {
            this.lpgCond = true;
          }

          // console.log(dayDifferences);

          this.displayProductSummary(response.data);
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getSalesTarget() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/SalesTarget/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          let productCount = 0;
          if (response.data.length > 0) {
            let pmssalesTarget = response.data.filter(
              (prod) =>
                prod.productName.toLowerCase() ==
                this.countryProducts.productsLower.product1
            );
            if (pmssalesTarget.length) {
              this.pmssalesTarget = pmssalesTarget[0].target;
            }
            let agosalesTarget = response.data.filter(
              (prod) =>
                prod.productName.toLowerCase() ==
                this.countryProducts.productsLower.product2
            );
            if (agosalesTarget.length) {
              this.agosalesTarget = agosalesTarget[0].target;
            }
            let dpksalesTarget = response.data.filter(
              (prod) =>
                prod.productName.toLowerCase() ==
                this.countryProducts.productsLower.product3
            );
            if (dpksalesTarget.length) {
              this.dpksalesTarget = dpksalesTarget[0].target;
            }
            let lpgsalesTarget = response.data.filter(
              (prod) =>
                prod.productName.toLowerCase() ==
                this.countryProducts.productsLower.product4
            );
            if (lpgsalesTarget.length) {
              this.lpgsalesTarget = lpgsalesTarget[0].target;
            }

            let ps = parseFloat(
              this.decimalThousand((this.pmsSale / this.pmssalesTarget) * 100)
            );
            this.pmsGuageOptions.series[0].data[0].y = ps;

            let as = parseFloat(
              this.decimalThousand((this.agoSale / this.agosalesTarget) * 100)
            );
            this.agoGuageOptions.series[0].data[0].y = as;

            let ds = parseFloat(
              this.decimalThousand((this.dpkSale / this.dpksalesTarget) * 100)
            );
            this.dpkGuageOptions.series[0].data[0].y = ds;

            let ls = parseFloat(
              this.decimalThousand((this.lpgSale / this.lpgsalesTarget) * 100)
            );
            this.dpkGuageOptions.series[0].data[0].y = ls;
          }
        })
        .catch((error) => {});
    },
    getPumpCount() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/PumpCount/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.pumpCount = response.data.pumpCount;
        })
        .catch((error) => {});
    },
    getTanksFilled() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/CompanyTanksFilled/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.tanksFilled = response.data;
        })
        .catch((error) => {});
    },
    getTankStock() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/TankStock/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.tankStockSummary(response.data);
          this.showLoader = false;
          const groups = response.data.reduce((groups, sales) => {
            const branchName = sales.branchName;
            if (!groups[branchName]) {
              groups[branchName] = [];
            }
            groups[branchName].push(sales);
            return groups;
          }, {});
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getOfflinePmps() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/OfflinePumpCount/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.offlinePumps = response.data.offline;
        })
        .catch((error) => {});
    },
    getPaymentChannelsData() {
      if (this.loadedFirst == true) {
        this.loadingNT = false;
      } else {
        this.loadingNT = true;
      }

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/CompanyPaymentChannel/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          // this.loadingNT = false;
          // console.log(response);
          this.pcbankDeposit = this.convertThousand(response.data.bankDeposit);
          this.pcdirectBankDeposit = this.convertThousand(
            response.data.directBankDeposit
          );
          this.pcpayDirectBankDeposit = this.convertThousand(
            response.data.payDirectBankDeposit
          );
          this.pccash = this.convertThousand(response.data.cash);
          this.pccurrency = response.data.currency;
          this.pcesales = this.convertThousand(response.data.esales);
          this.pcretainership = this.convertThousand(
            response.data.retainership
          );
          this.pcoutstandingCash = this.convertThousand(
            response.data.outstandingCash
          );
          this.pcposSales = this.convertThousand(response.data.posSales);
          this.pcWalletTU = this.convertThousand(response.data.walletTopUp);
          this.loadingNT = false;
        })
        .catch((error) => {
          this.loadingNT = true;
        });
    },
    getRevenueData() {
      if (this.loadedFirst == true) {
        this.loadingNT2 = false;
      } else {
        this.loadingNT2 = true;
      }
      // this.loadingNT2 = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/CompanyRevenue/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          // this.loadingNT2 = false;
          // console.log(response.data);
          this.pcbalance = response.data.balance;
          this.pccurrency2 = response.data.currency;
          this.pcdryStock = response.data.dryStock;
          this.pcexpenses = response.data.expenses;
          this.pcwetStock = response.data.wetStock;
          this.pcrtt = response.data.rtt;
          this.loadingNT2 = false;
        })
        .catch((error) => {
          this.loadingNT2 = true;
        });
    },
    getDeviceNotPushing() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/DeviceNotPushingCount/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.deviceNotPushing = response.data.faultyPumps;
        })
        .catch((error) => {});
    },
    openModal() {
      this.$modal.show("companyDomain");
    },
    getLowTanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/CompanyTanksProjection/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((element) => {
            element.lastDate = this.timeSince(new Date(element.lastDate));
            element.branchName = `${element.branchName}`;
            element.tankEmptyProjectionDate = new Date(
              element.tankEmptyProjectionDate
            ).toDateString();
            element.nextTwoDaysTankVolume =
              element.nextTwoDaysTankVolume.toLocaleString();

            let percent;
            if (
              element.currentVolume <= 0 ||
              element.maxCapacity <= 0 ||
              element.currentVolume == null ||
              element.maxCapacity == null
            ) {
              element.percent = 0;
              element.height = 147;
            } else {
              percent = (element.currentVolume * 100) / element.maxCapacity;
              element.percent = percent.toFixed(1);
              element.height = parseInt(
                150 - (element.currentVolume / element.maxCapacity) * 140
              );
            }

            if (percent <= 30) {
              element.color = "red";
            }
            if (percent > 50) {
              element.color = "green";
            }
            if (percent > 30 && percent <= 50) {
              element.color = "blue";
            }
          });
          response.data.sort(function (a, b) {
            return a.height - b.height;
          });
          this.lowTanks = response.data.filter((tank) => tank.maxCapacity > 0);
        })
        .catch((error) => {});
    },

    timeSince(date) {
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = Math.floor(seconds / 31536000);

      if (interval > 1) {
        return interval + " years";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + " minutes";
      }
      return Math.floor(seconds) + " seconds";
    },
    getHistoryChartsData() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/CompanyFiveDaySale/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((el) => {
            if (
              el.product.toLowerCase() ===
              this.countryProducts.productsLower.product4
            ) {
              this.availableProducts.push(
                this.countryProducts.productsLower.product4
              );
              this.hasLpg = true;
            } else if (
              el.product.toLowerCase() ===
              this.countryProducts.productsLower.product1
            ) {
              this.availableProducts.push(
                this.countryProducts.productsLower.product1
              );
              this.hasPms = true;
            } else if (
              el.product.toLowerCase() ===
              this.countryProducts.productsLower.product2
            ) {
              this.availableProducts.push(
                this.countryProducts.productsLower.product2
              );
              this.hasAgo = true;
            } else if (
              el.product.toLowerCase() ===
              this.countryProducts.productsLower.product3
            ) {
              this.availableProducts.push(
                this.countryProducts.productsLower.product3
              );
              this.hasDpk = true;
            }
          });
          let uniqueList = [...new Set(this.availableProducts)];
          this.availableProducts = uniqueList;
          let productsLength = this.availableProducts.length;
          let targetsColNum = productsLength == 4 ? 3 : 4;
          this.salesTargetCount = `col-lg-${targetsColNum}`;
          this.getting = false;
          this.paintSplineData(response.data);
        })
        .catch((error) => {});
    },
    getCompanyBranchSales() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/CompanyBranchSales/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.hasGroup = response.data.hasGroups;

          let groupArrays;

          // response.data.data.sort((a, b) => {
          // 	var x = a.branchName.toLowerCase();
          // 	var y = b.branchName.toLowerCase();
          // 	if (x < y) {
          // 		return -1;
          // 	}
          // 	if (x > y) {
          // 		return 1;
          // 	}
          // 	return 0;
          // });
          let groups;
          if (!this.hasGroup) {
            groups = response.data.data.reduce((groups, sales) => {
              const branchName = sales.branchName;
              if (!groups[branchName]) {
                groups[branchName] = [];
              }
              groups[branchName].push(sales);
              return groups;
            }, {});
          } else {
            groups = response.data.data.reduce((groups, sales) => {
              const branchName = sales.region;

              if (!groups[branchName]) {
                groups[branchName] = [];
              }
              groups[branchName].push(sales);
              return groups;
            }, {});
          }
          let count = 0;
          groupArrays = Object.keys(groups).map((branchName) => {
            const pmsV = groups[branchName].filter(
              (sl) =>
                sl.productName.toLowerCase() ==
                this.countryProducts.productsLower.product1
            );
            const agoV = groups[branchName].filter(
              (sl) =>
                sl.productName.toLowerCase() ==
                this.countryProducts.productsLower.product2
            );
            const dpkV = groups[branchName].filter(
              (sl) =>
                sl.productName.toLowerCase() ==
                this.countryProducts.productsLower.product3
            );
            const lpgV = groups[branchName].filter(
              (sl) =>
                sl.productName.toLowerCase() ==
                this.countryProducts.productsLower.product4
            );

            return {
              branchName: branchName.trim(),
              region: groups[branchName][0].region,
              state: groups[branchName][0].state,
              regionId: groups[branchName][0].regionId,
              pmsVolume: pmsV.length
                ? this.convertThousand(pmsV[0].volumeSold)
                : "",
              pmsAmount: pmsV.length
                ? this.convertThousand(pmsV[0].amountSold)
                : "",
              agoVolume: agoV.length
                ? this.convertThousand(agoV[0].volumeSold)
                : "",
              agoAmount: agoV.length
                ? this.convertThousand(agoV[0].amountSold)
                : "",
              dpkVolume: dpkV.length
                ? this.convertThousand(dpkV[0].volumeSold)
                : "",
              dpkAmount: dpkV.length
                ? this.convertThousand(dpkV[0].amountSold)
                : "",
              lpgVolume: lpgV.length
                ? this.convertThousand(lpgV[0].volumeSold)
                : "",
              lpgAmount: lpgV.length
                ? this.convertThousand(lpgV[0].amountSold)
                : "",
              totalAmount: this.convertThousand(
                groups[branchName].reduce((acc, currValue) => {
                  return acc + currValue.amountSold;
                }, 0)
              ),
            };
          });

          groupArrays.sort((a, b) => {
            return a.branchName > b.branchName
              ? 1
              : a.branchName < b.branchName
              ? -1
              : 0;
          });

          groupArrays.forEach((el) => (el.index = ++count));

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: groupArrays,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    getTransactionCount() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Report/Company/ProductSalesCount/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let branchSale = res.data.map((item) => {
            return (
              item.dpKcount + item.pmScount + item.lpGcount + item.agOcount
            );
          });
          this.transaction_count = branchSale.reduce(
            (prev, cur) => prev + cur,
            0
          );
        })
        .catch((error) => {});
    },
    paintSplineData(splineData) {
      if (splineData.length > 0) {
        //PMS
        let pms = splineData.filter(
          (trans) =>
            trans.product.toLowerCase() ===
            this.countryProducts.productsLower.product1
        );
        let pmsValueArray = [];
        pms.forEach((element) => {
          pmsValueArray.push(element.volume);
        });
        const label = pms.map((cur) =>
          cur.date.split("T")[0].split("-").reverse().join("-")
        );
        let length = pmsValueArray.length;
        let curr = pmsValueArray[length - 1];
        let prev = pmsValueArray[length - 2];
        this.pmsRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.pmsRate = !isFinite(this.pmsRate) ? 0.0 : this.pmsRate;
        if (this.pmsRate < 0) {
          this.pmsUp = false;
          this.pmsRateColor = "red";
        } else {
          this.pmsUp = true;
          this.pmsRateColor = "green";
        }
        this.pmsRate = Math.abs(this.pmsRate);
        let pmsSeries = new Array({ name: "", data: pmsValueArray });
        this.pmsSplineOption.series = pmsSeries;
        this.pmsSplineOption.series[0].color = "#d8991c";
        this.pmsSplineOption.xAxis.categories = label;

        //AGO
        let ago = splineData.filter(
          (trans) =>
            trans.product.toLowerCase() ===
            this.countryProducts.productsLower.product2
        );
        let agoValueArray = [];
        ago.forEach((element) => {
          agoValueArray.push(element.volume);
        });
        length = pmsValueArray.length;
        curr = agoValueArray[length - 1];
        prev = agoValueArray[length - 2];
        this.agoRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.agoRate = !isFinite(this.agoRate) ? 0.0 : this.agoRate;
        if (this.agoRate < 0) {
          this.agoUp = false;
          this.agoRateColor = "red";
        } else {
          this.agoUp = true;
          this.agoRateColor = "green";
        }
        this.agoRate = Math.abs(this.agoRate);
        let agoSeries = new Array({ name: "", data: agoValueArray });
        this.agoSplineOption.series = agoSeries;
        this.agoSplineOption.series[0].color = "#0fce29";
        this.agoSplineOption.xAxis.categories = label;

        //DPK
        let dpk = splineData.filter(
          (trans) =>
            trans.product.toLowerCase() ===
            this.countryProducts.productsLower.product3
        );
        let dpkValueArray = [];
        dpk.forEach((element) => {
          dpkValueArray.push(element.volume);
        });
        curr = dpkValueArray[length - 1];
        prev = dpkValueArray[length - 2];
        this.dpkRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.dpkRate = !isFinite(this.dpkRate) ? 0.0 : this.dpkRate;
        if (this.dpkRate < 0) {
          this.dpkUp = false;
          this.dpkRateColor = "red";
        } else {
          this.dpkUp = true;
          this.dpkRateColor = "green";
        }
        this.dpkRate = Math.abs(this.dpkRate);
        let dpkSeries = new Array({ name: "", data: dpkValueArray });
        this.dpkSplineOption.series = dpkSeries;
        this.dpkSplineOption.series[0].color = "#00aced";
        this.dpkSplineOption.xAxis.categories = label;

        //LPG
        let lpg = splineData.filter(
          (trans) =>
            trans.product.toLowerCase() ===
            this.countryProducts.productsLower.product4
        );
        let lpgValueArray = [];
        lpg.forEach((element) => {
          lpgValueArray.push(element.volume);
        });
        length = pmsValueArray.length;
        curr = lpgValueArray[length - 1];
        prev = lpgValueArray[length - 2];
        this.lpgRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.lpgRate = !isFinite(this.lpgRate) ? 0.0 : this.lpgRate;
        if (this.lpgRate < 0) {
          this.lpgUp = false;
          this.lpgRateColor = "red";
        } else {
          this.lpgUp = true;
          this.lpgRateColor = "green";
        }
        this.lpgRate = Math.abs(this.lpgRate);
        let lpgSeries = new Array({ name: "", data: lpgValueArray });
        this.lpgSplineOption.series = lpgSeries;
        this.lpgSplineOption.series[0].color = "#80008026";
        this.lpgSplineOption.xAxis.categories = label;

        //TOTAL
        const groups = splineData.reduce((groups, product) => {
          const date = product.date.split("T")[0];
          if (!groups[date]) {
            groups[date] = [];
          }
          groups[date].push(product);
          return groups;
        }, {});

        const groupArrays = Object.keys(groups).map((date) => {
          return {
            date,
            volume: groups[date].reduce((acc, currValue) => {
              return acc + currValue.volume;
            }, 0),
          };
        });

        let totalValueArray = [];
        groupArrays.forEach((element) => {
          totalValueArray.push(element.volume);
        });
        length = totalValueArray.length;
        curr = totalValueArray[length - 1];
        prev = totalValueArray[length - 2];
        this.totalRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.totalRate = !isFinite(this.totalRate) ? 0.0 : this.totalRate;
        if (this.totalRate < 0) {
          this.totalUp = false;
          this.totalRateColor = "red";
        } else {
          this.totalUp = true;
          this.totalRateColor = "green";
        }
        this.totalRate = Math.abs(this.totalRate);
        let totalSeries = new Array({ name: "", data: totalValueArray });
        this.totalSplineOption.series = totalSeries;
        this.totalSplineOption.series[0].color = "#ff7c71";
        this.totalSplineOption.xAxis.categories = label;
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toggleShowAll(event) {
      if (this.showAll === true) {
        this.showAll = false;
        event.target.innerHTML = "Show All";
      } else {
        this.showAll = true;
        event.target.innerHTML = "Show Less";
      }
    },
    decimalThousand(number) {
      if (!isFinite(number)) {
        return "0.00";
      }
      return number
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
.no-tank {
  font-size: 20px;
  font-weight: 500;
  margin-top: 10%;
}
.full-div {
  height: 100% !important;
  margin-top: 40px !important;
}

.full-div .section___column_2 {
  margin-bottom: 70px !important;
}

.full-div .highcharts__row {
  margin-bottom: 70px !important;
}

.date-picker {
  width: 98%;
  margin: auto;
}
.drop_down_div {
  width: 35%;
}

a {
  color: black !important;
}
.loading {
  width: 100% !important;
  border-radius: 10px;
}
@media only screen and (max-width: 500px) {
  .drop_down_div {
    width: 54%;
  }
}
.remisAD {
  width: 98% !important;
  margin: auto;

  object-fit: fill;
}

@media screen and (max-width: 780px) {
  .remisAD {
    margin-top: -100px;
  }
  .mobMarg {
    margin-top: 20px;
  }
  .boxMarg {
    margin-top: 100px !important;
  }
}

@media screen and (min-width: 780px) {
  .scoll-pane {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: auto;
    overflow: auto;
    outline: none;
    overflow-y: hidden;
    -ms-overflow-style: scroll;
    scrollbar-width: none;
  }

  .scoll-pane::-webkit-scrollbar {
    display: none;
  }

  .arrow-div-left,
  .arrow-div-right {
    display: block !important;
  }
}

.arrowpics:hover {
  width: 50px;
}

.arrow-div-left {
  top: 200px;
  cursor: pointer;
  display: none;
}
.arrow-div-right {
  top: 200px;
  right: 20px;
  cursor: pointer;
  display: none;
}

@media screen and (max-width: 600px) {
  .remisAD {
    height: 110px !important;
    margin-top: -20px;
  }
}

/* .hovWS:hover {
  background-color: #e9ecef;
} */
</style>
